"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.coreUsersByIdPictureGetAsyncSlice = void 0;
const _api_1 = require("../../../../api/index.js");
const actions_1 = require("../../_idMap/actions.js");
const xuder_1 = require("@sonar-software/xuder");
exports.coreUsersByIdPictureGetAsyncSlice = (0, xuder_1.createGetAsyncSlice)({
    httpSagaOptions: {
        preRequestActionCreators: [
            (request) => (0, actions_1.updateUserReferences)([
                {
                    profilePictureTimestamp: Date.now(),
                    userId: request.userId
                }
            ])
        ],
        successCombinationActionCreators: [
            (request, response) => (0, actions_1.updateUserReferences)([
                {
                    profilePicture: response ? URL.createObjectURL(response) : undefined,
                    profilePictureTimestamp: Date.now(),
                    userId: request.userId
                }
            ])
        ]
    },
    name: 'CoreUsersByIdPicture',
    receive: true,
    request: true,
    requestHandler: _api_1.getUserProfilePicture,
    yieldType: xuder_1.SagaYieldType.Every
});
//# sourceMappingURL=get.js.map